import React, { memo, forwardRef } from 'react';

import cls from 'classnames';

import IconCheck from '@ott/icon-check';

import styles from './Checkbox.scss';

type OmitHTMLInputProps = Omit<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'onChange' | 'size' | 'ref' | 'checked' | 'disabled'
>;

export type Props = React.PropsWithChildren<
  OmitHTMLInputProps & {
    /** Состояние checked */
    isChecked: boolean;

    /** Состояние disabled */
    isDisabled?: boolean;

    /** Класснейм для контейнера лейбла-чилдрена */
    labelClassName?: string;

    /** Размер чекбокса */
    size?: 'small' | 'default';

    /** Определяет состояние ошибки */
    hasError?: boolean;

    /** Дополнительные дата-локаторы */
    specificLocators?: string | string[];

    /** Колбэк для изменения значения */
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }
>;

const Checkbox = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    className,
    labelClassName,

    size = 'default',

    isChecked,

    isDisabled,
    hasError,

    children,

    specificLocators,

    onChange,

    ...forwardedProps
  }: Props = props;

  return (
    <label
      className={cls(styles.root, className, {
        [styles.rootChecked]: isChecked,
        [styles.rootDisabled]: isDisabled,
        [styles.rootError]: hasError,
        [styles.rootDefaultSize]: size === 'default',
        [styles.rootSmallSize]: size === 'small',
      })}
      data-locator={cls('checkbox', specificLocators)}
    >
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...forwardedProps}
        ref={ref}
        type="checkbox"
        className={styles.control}
        checked={isChecked}
        disabled={isDisabled}
        data-error-type="new"
        aria-checked={isChecked}
        onChange={onChange}
      />
      <div className={styles.box}>
        <IconCheck className={styles.icon} />
      </div>
      {children && <div className={cls(styles.label, labelClassName)}>{children}</div>}
    </label>
  );
});

export default memo(Checkbox);
